import React from "react";
import { StyledContainer, StyledImage } from "./styled";
import { useIconsByFinance } from "../../utils/useIconsByFinance";

/**
 * Server Request Loading Screen Component
 * Displays a loading indicator while server requests are in progress
 * @returns {JSX.Element} The loading screen component
 */
export const ServerRequestLoadingScreen = () => {
  const { awaiting } = useIconsByFinance();

  return (
    <StyledContainer data-testid="loading-screen">
      <StyledImage src={awaiting} alt="Loading" />
    </StyledContainer>
  );
};
